"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfCitationMarkdownDirectiveDefinition = void 0;
exports.parsePdfCitationElementIndexes = parsePdfCitationElementIndexes;
exports.formatPdfCitationDirective = formatPdfCitationDirective;
const MarkdownDirectiveDefinition_1 = require("./MarkdownDirectiveDefinition");
exports.PdfCitationMarkdownDirectiveDefinition = Object.freeze({
    allowedAttributes: ['citationText', 'fileId', 'elementIndex', 'pageNumber', 'citedText', 'description'],
    contentAttributeName: 'citationText',
    directive: 'pdf-citation',
    nodeTypes: [MarkdownDirectiveDefinition_1.NodeTypes.TextDirective],
});
function parsePdfCitationElementIndexes(value) {
    if (value === undefined || value === null) {
        return null;
    }
    const parts = typeof value === 'number' ?
        [value]
        : value
            .split(',')
            .map((part) => part.trim())
            .filter((part) => part !== '')
            .map((part) => Number(part));
    const indexes = parts.filter((part) => Number.isInteger(part) && part >= 0);
    if (indexes.length === 0 || indexes.length !== parts.length) {
        return null;
    }
    return [...new Set(indexes)].sort((left, right) => left - right);
}
function formatPdfCitationDirective({ citationText, fileId, elementIndex, elementIndexes, pageNumber, citedText, description, }) {
    if (fileId.trim() === '') {
        throw new Error('A PDF citation requires a fileId');
    }
    const normalizedCitedText = citedText?.trim();
    const effectiveIndexes = elementIndexes !== undefined && elementIndexes !== null ? [...elementIndexes]
        : elementIndex !== undefined && elementIndex !== null ? [elementIndex]
            : null;
    if (effectiveIndexes === null) {
        if ((pageNumber === undefined || pageNumber === null) && !normalizedCitedText) {
            throw new Error('A PDF citation requires an elementIndex, pageNumber, or citedText');
        }
    }
    else if (effectiveIndexes.length === 0 || effectiveIndexes.some((index) => !Number.isInteger(index) || index < 0)) {
        throw new Error('A PDF citation elementIndex must be a non-negative integer');
    }
    if (pageNumber !== undefined && pageNumber !== null && (!Number.isInteger(pageNumber) || pageNumber < 1)) {
        throw new Error('A PDF citation pageNumber must be a positive integer');
    }
    const attributes = [`fileId=${(0, MarkdownDirectiveDefinition_1.quoteDirectiveAttribute)(fileId)}`];
    if (effectiveIndexes !== null) {
        const serializedIndexes = [...new Set(effectiveIndexes)].sort((left, right) => left - right).join(',');
        attributes.push(serializedIndexes.includes(',') ?
            `elementIndex=${(0, MarkdownDirectiveDefinition_1.quoteDirectiveAttribute)(serializedIndexes)}`
            : `elementIndex=${serializedIndexes}`);
    }
    if (pageNumber !== undefined && pageNumber !== null) {
        attributes.push(`pageNumber=${pageNumber}`);
    }
    if (normalizedCitedText) {
        attributes.push(`citedText=${(0, MarkdownDirectiveDefinition_1.quoteDirectiveAttribute)(normalizedCitedText)}`);
    }
    if (description !== undefined && description !== null && description !== '') {
        attributes.push(`description=${(0, MarkdownDirectiveDefinition_1.quoteDirectiveAttribute)(description)}`);
    }
    return `:${exports.PdfCitationMarkdownDirectiveDefinition.directive}[${(0, MarkdownDirectiveDefinition_1.escapeDirectiveContent)(citationText)}]{${attributes.join(' ')}}`;
}
//# sourceMappingURL=PdfCitation.js.map